import VueShepherdPlugin from 'vue-shepherd';
//import '~shepherd.js/dist/css/shepherd.css';

export default defineNuxtPlugin((nuxtApp) => {
  // now available on `nuxtApp.$injected`
  nuxtApp.vueApp.use(VueShepherdPlugin)
})
